import Box from '@mui/material/Box';
import { type JSX, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type {
  AudienceListType,
  FormSegment,
  SegmentTreeNode,
} from '../../../../../../../../modules/audiences/AudienceForm/types.ts';
import { Tree } from '../../treeList/Tree.tsx';
import { transformSegmentsToStateDistrictTree } from './utils/transformSegmentsToStateDistrictTree.ts';

export type CongressionalDistrictsTreeListProps = {
  locationSegments: FormSegment[];
  listType: AudienceListType;
  onSegmentDelete?: (segment: FormSegment) => void;
  readOnly?: boolean;
  allSegments: SegmentTreeNode[];
};

export const CongressionalDistrictsTreeList = ({
  locationSegments,
  listType,
  onSegmentDelete,
  readOnly = false,
  allSegments,
}: CongressionalDistrictsTreeListProps): JSX.Element | null => {
  const { t } = useTranslation();

  const congressionalTreeItems = useMemo(
    () => transformSegmentsToStateDistrictTree(locationSegments, allSegments),
    [locationSegments, allSegments]
  );

  if (!locationSegments?.length) {
    return null;
  }

  const treeProps = readOnly
    ? { readOnly: true as const }
    : {
        readOnly: false as const,
        onLeafDelete: (node: SegmentTreeNode) => {
          if (onSegmentDelete) {
            onSegmentDelete(node);
          }
        },
      };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        flexDirection: 'column',
      }}
    >
      <Tree title={t('Included')} treeItems={congressionalTreeItems} type={listType} {...treeProps} />
    </Box>
  );
};
